import { TYPES } from '../actions';

const initialState = {
  versions: {},  // Indexed by product_code
  loading: false,
  error: null
};

export const sesProductVersionReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPES.ACTION_GET_SES_PRODUCTS_VERSION_SUCCESS:
      return {
        ...state,
        versions: {
          ...state.versions,
          [action.payload.product_code]: action.payload.data
        },
        loading: false,
        error: null
      };

    case TYPES.ACTION_GET_SES_PRODUCTS_VERSION_FAIL:
      return {
        ...state,
        versions: {
          ...state.versions,
          [action.payload.product_code]: null
        },
        loading: false,
        error: 'Failed to load product versions'
      };

    default:
      return state;
  }
}; 